export default __webpack_public_path__ + "static/media/higher_primary_logo_url_1.f6add3d5.svg";